import React from 'react';
export const Confirmation = React.lazy(() => import('./Confirmation.jsx'));
